import { Observable } from 'rxjs';
import { fetchEventSource, FetchEventSourceInit } from '@microsoft/fetch-event-source';

export const createSSEObservable = (url: string, options: RequestInit): Observable<string> => {
  return new Observable((subscriber) => {
    const controller = new AbortController();

    const eventSourceInit: FetchEventSourceInit = {
      ...options,
      openWhenHidden: true,
      credentials: 'include',
      signal: controller.signal,
      headers: options.headers
        ? Object.fromEntries(new Headers(options.headers).entries())
        : undefined,
      onmessage(msg) {
        if (msg.event === 'streamNotFound') {
          subscriber.error(msg);
          controller.abort();
        }
        subscriber.next(msg.data);
      },
      onerror(err) {
        subscriber.error(err);
        controller.abort();
      },
      onclose() {
        subscriber.complete();
      },
    };

    fetchEventSource(url, eventSourceInit);

    return () => {
      controller.abort();
    };
  });
};
